export class ListPacParametroPeticion{
     idFacturador: number = -1;
     idConvenio: string = '-1';
}